<template>
	<div class="row">
		<div class="col-xl-4 col-md-6 col-sm-12 col-12 mb-4" v-for="tarif of selectedTarifes" :key="tarif.id">
			<CardTarif :tarif="tarif" @connect="connect" />
		</div>
	</div>
</template>

<script>
import CardTarif from "@/main/CardTarif";
export default {
	name: "Section",
	components: {CardTarif},
	props: {
		tarifes: Array,
		internet: Boolean,
		phone: Boolean,
		tv: Boolean
	},
	emits: [
		"connect"
	],
	computed: {
		selectedTarifes() {
			return this.tarifes.filter(tarif => tarif.internet == this.internet
				&& tarif.phone == this.phone && tarif.tv == this.tv);
		}
	},
	methods: {
		connect(e) {
			this.$emit('connect', e);
		}
	}
}
</script>
